import {z} from "zod/v4-mini"
import type {BaseGraphNodeDefinition} from "#graph/nodes/base/types"

export const circularRefNodeDefinition = {
    nodeClass: "CircularRef",
    validation: {
        parameters: z.object({refId: z.number()}),
    },
} satisfies BaseGraphNodeDefinition<{refId: number}>
